// Сгенерировано scripts/mapgen-v8/export.py — версия файлов карты v8 (для кэша сервис-воркера).
export const V8_VERSION = 'a0a72fcb7d';
